import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import AskUpgrade from '../../components/AskUpgrade.js';
import ColumnPicker from "../../components/ColumnPicker";
import OptionColumn from "../../components/general/OptionColumn";
import Template from "./template";
import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import SplitRows from '../../components/general/SplitRow.js';

class Templates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askCreate:false,
            askUpgrade:false,
            askDelete:false,
            followUpFor:false,
            templates:[],
            currentId:false,
            showDialog:false,
        }

        this.handleSave = this.handleSave.bind(this);
        this.update = this.update.bind(this);
        this.portal = this.portal.bind(this);
        this.askDelete = this.askDelete.bind(this);
        this.delete = this.delete.bind(this);
    }

    askDelete(id) {
        this.setState({askDelete:id});
    }

    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }

    delete(id) {
        this.setState({askDelete:false,isLoading:true});
        axios.delete('/recommendations/templates/'+id).then(res => {
            this.update();
        });
    }


    portal() {
        return (
            <Portal closeOnEsc onClose={e => {this.setState({currentId:false,showDialog:false})}} isOpened={this.state.showDialog}>
                <FullScreenOverlay>
                    <Template handleSave={this.handleSave} enabled={true} onClose={e => {this.setState({currentId:false,showDialog:false})}} recommendationId={this.state.currentId} />
                </FullScreenOverlay>
            </Portal>
        )
    }

    handleSave() {
        this.update();
    }

    update() {
        axios.get(`/recommendations/templates`)
            .then(res => {

                res.data = res.data.filter(template => {
                    return template.isLocked !== true;
                });

                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'templates':res.data
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }

    duplicate(id) {
        this.setState({
            isLoading:true,
        });

        axios.post('/recommendations/templates/'+id+'/duplicate').then((res) => {
            let templates = [
                ...this.state.templates
            ];

            templates.push(res.data);

            this.setState({isLoading:false,templates:templates});
        });
    }

    placeholderRow(rows,cols) {
        let td = [];
        for(let i = 1;i<=cols;i++) {
            td.push(<td key={i}>{this.placeholder()}</td>);
        }

        let row = [];
        for(let i = 1;i<=rows;i++) {
            row.push(<tr key={i}>{td}</tr>);
        }

        return row;
    }

    rows() {
        let data = this.placeholderRow(10,3);

        this.state.templates.map((template,i) => {
            data[i] =
                <tr key={`template-${template.id}`}>
                    <td>#{template.id}</td>
                    <td style={{textAlign:'left'}}>{template.description}</td>
                    <td>
                        <div className="btn-group" role="group">
                            <Tooltip placement="top" overlay={<span>Edit template</span>}>
                                <button onClick={(e) => { this.setState({currentId:template.id,showDialog:true}) }} className="btn btn-icon btn-default btn-outline"><i className="icon wb-pencil" aria-hidden="true"></i></button>
                            </Tooltip>

                            <Tooltip placement="top" overlay={<span>Duplicate template</span>}>
                                <button onClick={() => this.duplicate(template.id)} className="btn btn-icon btn-default btn-outline"><i className="icon wb-copy" aria-hidden="true"></i></button>
                            </Tooltip>

                            <Tooltip placement="top" overlay={<span>Delete template</span>}>
                                <button onClick={(e) => {this.askDelete(template.id)}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-trash" aria-hidden="true"></i></button>
                            </Tooltip>
                        </div>
                    </td>
                </tr>

        })

        return data;
    }

    componentWillMount() {
        this.update();
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        if(this.state.templates.length == 0) {
            return (
                <div className="page-content">
                    <Helmet title="Templates | Crall.io" />
                    <NoResult
                        header="No templates found"
                        body="You have not created a template yet. Click the button to get started."
                        action={(e) => { this.setState({currentId:0,showDialog:true}) }}
                        button="Create my first template"
                    />
                    {this.portal()}
                </div>
            );
        }

        return (
            <div className="full-height" id="tests">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-files-o"></i> Templates</span>
                    <div className="page-header-actions">

                        <div style={{marginRight:'10px'}} className="btn-group dropdown">
                            <button type="button" className="btn btn-dark dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                <i className="icon fa-plus" style={{marginRight:'10px'}}></i> Create new
                            </button>
                            <div className="dropdown-menu dropdown-menu-bullet dropdown-menu-right" role="menu">
                                <a onClick={(e) => { this.setState({currentId:0,showDialog:true}) }} className="dropdown-item" href="javascript:void(0)" role="menuitem">Template</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Templates | Crall.io" />

                    <OptionColumn title="Templates" cols={{'left':2,'right':10}} panel={false} description="List of all your templates.">

                    <table className="table outline text-left">
                        <tbody>
                        <tr>
                            <th>#</th>
                            <th style={{width:'75%',textAlign:'left'}}>Description</th>
                            <th>Actions</th>
                        </tr>
                        </tbody>



                        <tbody>
                        {this.rows()}
                        </tbody>
                    </table>
                    </OptionColumn>

                </div>
                <Confirm onAccept={(e) => { this.delete(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to delete this template?" />

                {this.portal()}
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Templates = connect(mapStateToProps,mapDispatchToProps)(Templates);
export default Templates;



// WEBPACK FOOTER //
// ./containers/recommendations/templates.js